import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import "./App.css";
import money_shower from "./money_shower_450.jpg";
import { computeReward, formatPrice } from "./compute";

export const App: React.FC = () => {
  const [reward, setReward] = useState(0);
  const priceInput = useRef<any>(null);

  useEffect(() => {
    priceInput.current.focus();
  }, []);

  const onPriceChange = (e: ChangeEvent<HTMLInputElement>) => {
    const price = +e.target.value;

    if (isNaN(price)) return;

    setReward(computeReward(price));
  };

  return (
    <div className="App">
      <div className="title">Odměna IS</div>
      <div>
        Cena: <input type="number" ref={priceInput} onChange={onPriceChange} />
      </div>
      <div className="spacer"></div>
      <div>
        Odměna: <b>{formatPrice(reward)}</b>
      </div>
      <div className="spacer-double"></div>
      <div className="money-image">
        <img src={money_shower} alt="We're gonna be rich!" />
      </div>
    </div>
  );
};
